/*
    triage0: "選択してください",
    triage3: "緊急：意識がおかしい",
    triage4: "準緊急：走行できない",
    triage5: "負傷している",
    triage6: "道具の故障",
    triage7: "リタイアする",
    triage8: "その他",
    triage8: "その他",
 
*/

const i18n = {
  main: {
    title: "レスキューNAVI",
    triage0: "選択してください",
    triage3: "緊急：意識がおかしい",
    triage4: "準緊急：歩行できない",
    triage5: "負傷している/体調が悪い",
    selfAidMsg: "自力で次のエイドまで辿り着ける場合は、通報を止め、救護所をお訪ねください。",
    callStaff: "スタッフを呼ぶ",
    reportNoTitle: "通報No",
    reportNo: "[新規]",
    resetNo: "通報Noをリセットしました",
    newReport: "新しく通報する",
    autoRefresh: "自動更新する",
    triageTitle: "傷病者の状況を教えてください",
    bibTitle: "傷病者のビブナンバー(スタッフの場合は配置）をご記入ください",
    bibInput: "傷病者のビブナンバー/スタッフの場合は配置",
    inputPhoneTitle: "連絡がとれる電話番号をご記入ください(本部よりお電話する場合がございます）",
    inputPhone: "電話番号",
    nameTitle: "あなたのお名前をご記入ください",
    nameInput: "通報者　氏名",
    mapTitle: "MAP上にご自身の位置が表示されているかご確認ください",
    mapAccurate: "精度：",
    mapAccurate2: "精度50m以下で通報できます",
    service1: "サービスのご利用にあたり、",
    serviceLink: "利用規約をご確認",
    service2: "、同意の上ご利用ください。",
    position: "※位置が表示されない場合、ブラウザの位置情報の利用を許可してください",
    confirm_msg: '地図の位置は正しいですか？',
    send_msg: '送信が完了しました。救護対応が開始されます。\nあなたが発見者の場合は、救護スタッフ到着まで、傷病者の側を離れないでください。',
    err_msg: '送信に失敗しました',
    kiyaku_url: 'https://n-sportstracking-lab.com/kiyaku',
  },
  main_en: {
    title: "Rescue NAVI",
    triage0: "Select.",
    triage3: "Urgent: Altered mental status.",
    triage4: "Semi-urgent: Unable to walk.",
    triage5: "Injured/Feeling unwell.",
    selfAidMsg: "If you can make it to the next aid station on your own, please stop reporting and seek assistance at the medical station.",
    callStaff: "Inform the staff",
    reportNoTitle: "Report No",
    reportNo: "[New]",
    resetNo: "The report number has been reset.",
    newReport: "Report a new incident",
    autoRefresh: "Auto Refresh",
    triageTitle: "Please provide information about the injured or ill person's condition.",
    bibTitle: "Please provide the bib number of the injured/ill person (or location for staff).",
    bibInput: "Bib number / location for staff",
    inputPhoneTitle: "Please provide a contact number",
    inputPhone: "Phone no",
    nameTitle: "Please provide your name.",
    nameInput: "Your fullname",
    mapTitle: "Please verify that your position is displayed on the map.",
    mapAccurate: "Accuracy: ",
    mapAccurate2: "Inform the staff is available if the accuracy is 50m or les",
    service1: "Regarding the use of our service,Please review and agree to",
    serviceLink: "the terms of service",
    service2: " before using our service.",
    position: "※If your location is not displayed, please allow the use of browser location information.",
    confirm_msg: 'Is the position on the map correct?',
    send_msg: 'Report sent.Rescue response will begin.\n If you are the discoverer, please stay with the injured or ill person until medical staff arrives.',
    err_msg: 'The report submission failed.',
    kiyaku_url: 'https://n-sportstracking-lab.com/kiyaku',
  },
  glocal: {
    mode: "GLOCAL",
    title: "GLOCEナビゲートサービス",
    triage0: "選択してください",
    triage8: "道に迷った",
    triage9: "その他",
    selfAidMsg: "",
    callStaff: "スタッフを呼ぶ",
    reportNoTitle: "通報No",
    reportNo: "[新規]",
    resetNo: "通報Noをリセットしました",
    newReport: "新しく通報する",
    autoRefresh: "自動更新する",
    triageTitle: "何にお困りでしょうか？",
    bibTitle: "お困りごとがあれば詳細をご記入ください",
    bibInput: "お困りごとがあれば詳細をご記入ください",
    inputPhoneTitle: "連絡がとれる電話番号をご記入ください(お電話する場合がございます）",
    inputPhone: "電話番号",
    inputEmailTitle: "メールアドレスを記入してください",
    inputEmail: "メールアドレス",
    nameTitle: "あなたのお名前をご記入ください",
    nameInput: "通報者　氏名",
    mapTitle: "MAP上にご自身の位置が表示されているかご確認ください",
    disp_accurate: "disable",
    mapAccurate: "精度：",
    mapAccurate2: "精度50m以下で通報できます",
    service1: "サービスのご利用にあたり、",
    serviceLink: "利用規約をご確認",
    service2: "、同意の上ご利用ください。",
    position: "※位置が表示されない場合、ブラウザの位置情報の利用を許可してください",
    confirm_msg: '地図の位置は正しいですか？',
    send_msg: '送信が完了しました。',
    err_msg: '送信に失敗しました',
    kiyaku_url: 'https://glocal.bz/tracking-kiyaku/',
    business_time_msg: '現在の時間はコンタクトセンター営業時間外（営業時間9:00-22:00）となっております。営業時間外は対応できない場合がございます。',
  },
  glocal_en: {
    mode: "GLOCAL",
    title: "GLOCE NAVIGATE SERVICE",
    triage0: "Please select",
    triage8: "Lost my way",
    triage9: "Other",
    selfAidMsg: "",
    callStaff: "Call staff",
    reportNoTitle: "Report No",
    reportNo: "[New]",
    resetNo: "Report No has been reset",
    newReport: "Submit a new report",
    autoRefresh: "Auto-refresh",
    triageTitle: "What is your concern?",
    bibTitle: "Please describe the details of your issue.",
    bibInput: "Please describe the details of your issue.",
    inputPhoneTitle: "Please enter a phone number where you can be reached (we may call you)",
    inputPhone: "Phone number",
    inputEmailTitle: "",
    inputEmail: "",
    nameTitle: "Please enter your name",
    nameInput: "Reporter’s Name",
    mapTitle: "Please check if your location is correctly displayed on the map",
    disp_accurate: "disable",
    mapAccurate: "Accuracy:",
    mapAccurate2: "Reports can be submitted with an accuracy of 50m or less",
    service1: "Before using the service,",
    serviceLink: "please review the Terms of Use",
    service2: " and agree before proceeding.",
    position: "※ If your location is not displayed, please enable location services in your browser settings.",
    confirm_msg: "Is the location on the map correct?",
    send_msg: "Submission completed.",
    err_msg: "Submission failed.",
    kiyaku_url: 'https://glocal.bz/tracking-kiyaku/',
    business_time_msg: "The current time is outside of our contact center business hours (9:00 AM - 10:00 PM). We may not be able to respond outside of business hours."
  },
  rescue: {
    title: "レスキューNAVI",
    triage0: "選択してください",
    triage3: "緊急：意識がおかしい",
    triage4: "流されている",
    triage6: "道具が故障した",
    selfAidMsg: "",
    callStaff: "スタッフを呼ぶ",
    reportNoTitle: "通報No",
    reportNo: "[新規]",
    resetNo: "通報Noをリセットしました",
    newReport: "新しく通報する",
    autoRefresh: "自動更新する",
    triageTitle: "あなたの状況を教えてください",
    bibTitle: "セールNoを記入",
    bibInput: "セールNo",
    inputPhoneTitle: "連絡がとれる電話番号をご記入ください",
    inputPhone: "電話番号",
    nameTitle: "あなたのお名前をご記入ください",
    nameInput: "通報者　氏名",
    mapTitle: "MAP上にご自身の位置が表示されているかご確認ください",
    mapAccurate: "精度：",
    mapAccurate2: "精度50m以下で通報できます",
    service1: "サービスのご利用にあたり、",
    serviceLink: "利用規約をご確認",
    service2: "、同意の上ご利用ください。",
    position: "※位置が表示されない場合、ブラウザの位置情報の利用を許可してください",
    confirm_msg: '地図の位置は正しいですか？',
    send_msg: '送信が完了しました。\nあなたが発見者の場合は、救護スタッフ到着まで、傷病者の側を離れないでください。',
    err_msg: '送信に失敗しました',
    kiyaku_url: 'https://n-sportstracking-lab.com/kiyaku',
  },
  rescue_en: {
    title: "Rescue NAVI",
    triage0: "Please select",
    triage3: "Emergency: Unconscious or disoriented",
    triage4: "Being swept away",
    triage6: "Equipment malfunction",
    selfAidMsg: "",
    callStaff: "Call staff",
    reportNoTitle: "Report No",
    reportNo: "[New]",
    resetNo: "Report No has been reset",
    newReport: "Submit a new report",
    autoRefresh: "Enable auto-refresh",
    triageTitle: "Please describe your condition",
    bibTitle: "Enter Sail No",
    bibInput: "Sail No",
    inputPhoneTitle: "Please enter a phone number where you can be contacted",
    inputPhone: "Phone number",
    nameTitle: "Please enter your name",
    nameInput: "Reporter name",
    mapTitle: "Please check if your location is displayed on the map",
    mapAccurate: "Accuracy:",
    mapAccurate2: "You can report if the accuracy is within 50m",
    service1: "Before using the service,",
    serviceLink: "please review the Terms of Use",
    service2: "and agree before proceeding.",
    position: "※ If your location is not displayed, please allow your browser to access location information.",
    confirm_msg: "Is your location on the map correct?",
    send_msg: "Submission completed. \nIf you are the first responder, please stay with the victim until rescue staff arrive.",
    err_msg: "Failed to send report",
    kiyaku_url: 'https://n-sportstracking-lab.com/kiyaku',
  },
  retire: {
    title: "レスキューNAVI",
    triage0: "選択してください",
    triage3: "緊急：意識がおかしい",
    triage4: "準緊急：走行できない",
    triage5: "負傷している",
    triage6: "道具の故障",
    triage7: "リタイアする",
    selfAidMsg: "",
    callStaff: "スタッフを呼ぶ",
    reportNoTitle: "通報No",
    reportNo: "[新規]",
    resetNo: "通報Noをリセットしました",
    newReport: "新しく通報する",
    autoRefresh: "自動更新する",
    triageTitle: "あなたの状況を教えてください",
    bibTitle: "ビブNoを記入",
    bibInput: "ビブNo",
    inputPhoneTitle: "連絡がとれる電話番号をご記入ください",
    inputPhone: "電話番号",
    nameTitle: "あなたのお名前をご記入ください",
    nameInput: "通報者　氏名",
    mapTitle: "MAP上にご自身の位置が表示されているかご確認ください",
    mapAccurate: "精度：",
    mapAccurate2: "精度50m以下で通報できます",
    service1: "サービスのご利用にあたり、",
    serviceLink: "利用規約をご確認",
    service2: "、同意の上ご利用ください。",
    position: "※位置が表示されない場合、ブラウザの位置情報の利用を許可してください",
    confirm_msg: '地図の位置は正しいですか？',
    send_msg: '送信が完了しました。\nあなたが発見者の場合は、救護スタッフ到着まで、傷病者の側を離れないでください。',
    err_msg: '送信に失敗しました',
    kiyaku_url: 'https://n-sportstracking-lab.com/kiyaku',
  },
  retire_en: {
    title: "Rescue NAVI",
    triage0: "Please select",
    triage3: "Emergency: Unconscious or disoriented",
    triage4: "Unable to continue",
    triage5: "Injured",
    triage6: "Equipment malfunction",
    triage7: "Retiring",
    selfAidMsg: "",
    callStaff: "Call staff",
    reportNoTitle: "Report No",
    reportNo: "[New]",
    resetNo: "Report No has been reset",
    newReport: "Submit a new report",
    autoRefresh: "Enable auto-refresh",
    triageTitle: "Please describe your situation",
    bibTitle: "Enter Bib No",
    bibInput: "Bib No",
    inputPhoneTitle: "Please enter a phone number where you can be contacted",
    inputPhone: "Phone number",
    nameTitle: "Please enter your name",
    nameInput: "Reporter name",
    mapTitle: "Please check if your location is displayed on the map",
    mapAccurate: "Accuracy:",
    mapAccurate2: "You can report if the accuracy is within 50m",
    service1: "Before using the service,",
    serviceLink: "please review the Terms of Use",
    service2: "and agree before proceeding.",
    position: "※ If your location is not displayed, please allow your browser to access location information.",
    confirm_msg: "Is your location on the map correct?",
    send_msg: "Submission completed.\nIf you are the first responder, please stay with the injured person until rescue staff arrive.",
    err_msg: "Failed to send report",
    kiyaku_url: 'https://n-sportstracking-lab.com/kiyaku',
  },


};

export default i18n;
